<template>
    <!--<transition   name="slide-fade" >-->
    <!--<div v-if="show">-->
    <!---->
    <!--</div>-->
    <!--</transition>-->
    <b-container class="pt-5 pb-3" id="footer">
        <b-row class="footer-main">

            <b-col lg="12" class="mx-auto" cols="12">
                <b-row>
                    <b-col lg="3" sm="3" md="3" cols="12">
                        <p class="footer-title">Sobre Gox</p>
                        <p class="footer-link" @click="goRouter('/nosotros')">Quiénes somos</p>
                        <p @click="openContacto()" class="footer-link">Contáctanos</p>
                        <p @click="openSugerencia()" class="footer-link">Sugerencias</p>
                        <p @click="goRouter('/fqa')" class="footer-link">Preguntas frecuentes</p>
                        <p @click="goRouter('/claim')" class="footer-link">Libros de Reclamaciones</p>
                    </b-col>
                    <b-col lg="3" sm="3" md="3" cols="12">
                        <p class="footer-title">Soy cliente</p>
                        <p class="footer-link" @click="goRouter('/usuario')">Puntos GOX</p>
                        <p class="footer-link" @click="goRouterParam()">Nuestros socios</p>
                    </b-col>
                    <b-col lg="3" sm="3" md="3" cols="12">
                        <p class="footer-title">Soy negocio</p>
                        <p class="footer-link" @click="goRouter('/contacto')">Quiero ser GOX</p>
                        <p class="footer-link" @click="goRouter('/negocio')">Cómo funciona</p>
                    </b-col>
                    <b-col lg="3" sm="3" md="3" cols="12" class="apps-desktop">
                        <p class="footer-title">Descarga la app</p>
                        <a :href="appStoreUrl" target="_blank">
                            <div class="d-sm-none d-md-block">
                                <img src="@/assets/images/store-play.png" alt="Google Play">
                            </div>
                        </a>
                    </b-col>
                    <b-col lg="3" sm="3" md="3" cols="12" class="apps-movil" style="flex-direction: column;">
                        <p class="footer-title">Descarga la app</p>
                        <div style="display: flex; justify-content: flex-start; width: 180px">
                            <a :href="appStoreUrl" target="_blank">
                                <div class="footer-cursor d-lg-none">
                                    <img src="@/assets/images/store-play.png" alt="Google Play">
                                </div>
                            </a>
                        </div>
                    </b-col>
                </b-row>
                <hr class="footer-separator">
                <b-row class="mt-1">
                    <b-col lg="4" sm="4" md="4" cols="12" class="logo-footer-desktop">
                        <div class="footer-cursor">
                            <img @click="goRouter('/home')" src="@/assets/images/logo-footer.svg" alt="Logo img">
                        </div>
                    </b-col>
                    <b-col class="d-flex align-items-center terms-polit" lg="3" sm="3" md="3" cols="12">
                        <p @click="goRouter('/condiciones')" class="footer-link">Términos y condiciones</p>
                    </b-col>
                    <b-col class="d-flex align-items-center terms-polit" lg="3" sm="3" md="3" cols="12">
                        <p @click="goRouter('/privacidad')" class="footer-link">Políticas de privacidad</p>
                    </b-col>
                    <b-col class="d-flex align-items-center terms-polit" lg="2" sm="2" md="2" cols="12">
                        <p @click="goRouter('/cookies')" class="footer-link">Política de cookies</p>
                    </b-col>

                    <b-col class="d-flex align-items-center socials" lg="2" sm="2" md="2" cols="12"
                        style="justify-content: center;">
                        <div class="footer-cursor">
                            <a :href="facebookUrl" target="_blank">
                                <img class="ml-2" src="@/assets/images/facebook.png" alt="Facebook Logo Img">
                            </a>
                            <a :href="instagramUrl" target="_blank">
                                <img class="ml-2" src="@/assets/images/instagram.png" alt="Instagram logo">
                            </a>
                            <a :href="linkedinUrl" target="_blank">
                                <img class="ml-2" src="@/assets/images/linkedin.png" alt="Linkedin Logo">
                            </a>
                            <a :href="youtubeUrl" target="_blank">
                                <img class="ml-2" src="@/assets/images/youtube.png" alt="Youtube Logo">
                            </a>
                        </div>
                    </b-col>
                    <b-col lg="4" sm="4" md="4" cols="12" class="logo-footer-movil" style="justify-content: center;">
                        <div class="footer-cursor">
                            <img @click="goRouter('/home')" src="@/assets/images/logo-footer.svg" alt="Logo Img">
                        </div>
                    </b-col>
                    <b-col style="justify-content: center; text-align: center;" class="rights-reservates">
                        <p @click="goRouter('/condiciones')" class="footer-link"> ®Todos los derechos reservados 2022</p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-modal hide-footer centrado headerClass="p-2 border-bottom-0" id="formulario-contacto-gox-footer"
            content-class="tomate-cafe-modal bg-black">
            <template v-slot:default>
                <div class="w-100 py-5 text-center">
                    <img class="cursor-pointer float-right modal-close-icon" :src="srcImagen('close.svg')"
                        @click="$bvModal.hide('formulario-contacto-gox-footer')" alt="Close svg">
                    <!-- <p class="my-4 tomate-cafe-titulo-form" v-html="content.texto_formulario"></p> -->
                    <p class=" mt-3 titulo" v-html="content.texto_formulario"></p>
                    <p class="subtitulo mb-0" v-html="content.subtitulo"></p>

                    <b-row class="mt-5">
                        <b-col class="col-5 mx-auto">
                            <div
                                v-if="content.address"
                                class="d-flex align-items-center"
                            >
                                <img src="@/assets/icons/pin.svg" class="d-block" alt="Pin img">
                                <span class="modal-address ml-auto mr-auto">
                                    {{ content.address }}
                                </span>
                            </div>
                            <div
                                v-if="content.phoneNumber"
                                class="d-flex align-items-center mt-4"
                            >
                                <img src="@/assets/icons/phone.svg" class="d-block" alt="Phone img">
                                <span class="modal-address ml-22">
                                    {{ content.phoneNumber }}
                                </span>
                            </div>
                            <div class="d-flex align-items-center mt-4">
                                <img src="@/assets/icons/icon_mail.svg" class="d-block" alt="Mail img">
                                <span class="modal-address ml-auto mr-auto">
                                    {{ content.email }}
                                </span>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </template>
        </b-modal>

        <b-modal hide-footer centrado headerClass="p-2 border-bottom-0" id="formulario-sugerencia-gox-footer"
            content-class="tomate-cafe-modal">
            <template v-slot:modal-header="{ close }">
                <div class="w-100 py-5 text-center">
                    <img class="cursor-pointer float-right modal-close-icon" :src="srcImagen('close.svg')" @click="close()" alt="Close img">
                    <!-- <p class="my-4 tomate-cafe-titulo-form" v-html="content.texto_formulario"></p> -->
                    <p class=" mt-3 titulo" v-html="content2.texto_formulario"></p>
                    <p class="subtitulo mb-0" v-html="content2.subtitulo"></p>
                </div>
            </template>
            <template v-slot:default>
                <formulario-2 :content="formulario2" />
            </template>
        </b-modal>
    </b-container>
</template>
<script>
// import Formulario from '@/components/Formulario'
import configs from '../local_config';
import Formulario2 from '@/components/Formulario2'

export default {
    name: 'Footer',
    components: { Formulario2 },
    data: () => ({
        show: false,
        facebookUrl: configs.FACEBOOK_URL,
        instagramUrl: configs.INSTAGRAM_URL,
        linkedinUrl: configs.LINKEDIN_URL,
        youtubeUrl: configs.YOUTUBE_URL,
        appStoreUrl: 'https://play.google.com/store/apps/details?id=com.puntosgox.app&hl=en',
        appleStoreUrl: '',
        formulario: {
            class_color: 'formulario-black',
            text_boton: 'Enviar',
            boton_img: false
        },
        formulario2: {
            class_color: 'formulario-black',
            text_boton: 'Enviar',
            boton_img: false
        },
        content: {
            texto_formulario: 'Contáctanos',
            // subtitulo: 'Nos puedes encontrar aquí.',
            // Se ocultan dirección y teléfono y solo se muestra el correo de contacto
            address: '',
            phoneNumber: '',
            email: 'atencionalcliente@puntosgox.com',
            description: 'Déjanos tu correo para poder contactarnos <br> contigo a la brevedad posible'
        },
        content2: {
            texto_formulario: 'SUGERENCIAS',
            subtitulo: 'Déjanos tus comentarios para seguir mejorando.'
        }
    }),
    created: function () {
        var self = this;
        setTimeout(() => {
            self.show = true
        }, 500);
    },
    methods: {
        goRouter(url) {
            this.$router.push(url)
        },
        openContacto() {
            this.$bvModal.show('formulario-contacto-gox-footer')
        },
        openSugerencia() {
            this.$bvModal.show('formulario-sugerencia-gox-footer')
        },
        srcImagen(img) {
            let src = require('@/assets/images/commerce_internal/' + img)
            return src
        },
        goRouterParam() {
            this.$router.push({
                name: 'home',
                hash: '#socios'
            })
        }
    }
}
</script>
<style scoped>
.apps-movil {
    display: none;
}

.socials {
    display: none;
}

.logo-footer-movil {
    display: none;
}

.rights-reservates {
    display: none;
}

@media (max-width: 600px) {
    .apps-movil {
        margin-top: 10px;
        display: flex;
    }

    .apps-desktop {
        display: none;
    }

    .logo-footer-desktop {
        display: none;
    }

    .logo-footer-movil {
        margin-top: 10px;
        display: flex;
    }

    .terms-polit {
        margin-top: 10px;
        justify-content: center;
    }

    .socials {
        margin-top: 10px;
        display: flex;
    }

    .footer-main {
        margin-top: 10px;
        margin-left: 10px !important;
        margin-right: 10px;
    }

    .rights-reservates {
        margin-top: 10px;
        display: flex;
    }
}
</style>
